import {
  SET_BUSINESS_INFO,
  SET_ACTIVATION,
  SET_CHARGE_TYPE,
  SET_CHARGE,
  CLEAR_CHARGE,
  SET_SUPERLOGICA_LIST,
  HANDLE_LOADING,
  CLEAR_BUSINESS_INFO_REGISTRATION
} from './constants';

import { formatDocument } from 'helpers/formatters';

const defaultState = {
  businessInfo: {
    establishmentTypes: [],
    establishmentName: '',
    documentId: '',
    phone: '',
    email: '',
    postalCode: '',
    street: '',
    number: '',
    complement: '',
    district: '',
    city: '',
    state: '',
    vacanciesMarks: ''
  },
  activation: {
    deactivatedEstablishmentTerms: false
  },
  charge: {
    chargeType: '',
    newClientSl: 0,
    superlogicaId: '',
    establishmentName: '',
    documentId: '',
    phone: '',
    email: '',
    postalCode: '',
    street: '',
    number: '',
    complement: '',
    district: '',
    city: '',
    state: ''
  },
  superlogicaList: [],
  isLoading: false
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_BUSINESS_INFO: {
      return {
        ...state,
        businessInfo: {
          ...state.businessInfo,
          ...action.data
        }
      }
    }
    case SET_ACTIVATION: {
      return {
        ...state,
        activation: {
          ...state.activation,
          ...action.data
        }
      }
    }
    case SET_CHARGE_TYPE: {
      return {
        ...state,
        charge: {
          ...state.charge,
          chargeType: action.chargeType
        }
      }
    }
    case SET_CHARGE: {
      return {
        ...state,
        charge: {
          ...state.charge,
          ...action.data
        }
      }
    }
    case CLEAR_CHARGE: {
      return {
        ...state,
        charge: {
          ...defaultState.charge,
          chargeType: state.charge.chargeType,
          newClientSl: state.charge.newClientSl,
          superlogicaId: state.charge.superlogicaId
        }
      }
    }
    case SET_SUPERLOGICA_LIST: {
      if(action?.data?.length == 0) {
        return {
          ...state,
          superlogicaList: []
        }
      }

      return {
        ...state,
        superlogicaList: action.data?.map(superlogica => {
          return {
            ...superlogica,
            label: !!superlogica?.documentId ? `${superlogica?.name} - ${formatDocument(superlogica?.documentId)}` : superlogica?.name,
            value: superlogica?.superlogicaId
          }
        })
      }
    }
    case HANDLE_LOADING: {
      return {
        ...state,
        isLoading: action.status
      }
    }
    case CLEAR_BUSINESS_INFO_REGISTRATION: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
}